module.exports = __webpack_public_path__ + "overdue-invoices-icon.png?5d4a10ea2b99b73916bac90f345597e9";